import React, {
  useState,
  useEffect,
  useRef,
  createRef
} from 'react'
import {Popover} from '@material-ui/core';

const SystemPopup = (props) => {
  const data = props.data;

  const [popoverContent, setPopoverContent] = useState(null);
  const [popoverAnchor, setPopoverAnchor] = useState(null);
  const [currentNode, setCurrentNode] = useState(null);

  // ⬇ https://stackoverflow.com/questions/55995760/how-to-add-refs-dynamically-with-react-hooks
  const elementsRef = useRef(data.popups.map(() => createRef()));

  useEffect(() => {
    window.addEventListener("scroll", function () {
      handlePopoverClose();
    }, false);
  }, [currentNode]);

  const handlePopoverOpen = (e) => {
    !e.currentTarget.classList.contains('active') && e.currentTarget.classList.add('active');
    setPopoverAnchor(e.currentTarget);
    // find correct data
    for (let i = 0; i < elementsRef.current.length; i++) {
      if (elementsRef.current[i].current === e.currentTarget) {
        setPopoverContent({
          img: data.popups[i].imgSrc,
          alt: data.popups[i].alt,
          text: data.popups[i].description,
          href: data.popups[i].href
        })
        // so we can remove active class in the future
        setCurrentNode(elementsRef.current[i].current);
        return true;
      }
    }

  }

  const handlePopoverClose = () => {
    setPopoverAnchor(null);
    setPopoverContent(null);
  };

  const handleMouseLeave = (e) => {
    e.currentTarget.classList.contains('active') && e.currentTarget.classList.remove('active');
  }

  return (
    <div className="system__container">
      <img className="system__img" src={data.src} alt={data.alt}/>
      {data.popups.map((item, index) => (
        <button
          className="system__btn"
          onMouseEnter={handlePopoverOpen}
          onMouseLeave={handleMouseLeave}
          onClick={handlePopoverOpen}
          style={{
            left: `${item.coords.x}%`,
            top: `${item.coords.y}%`
          }}
          ref={elementsRef.current[index]}
          key={index}>
          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
            <g transform="translate(-558 -695)">
              <rect width="36" height="36" transform="translate(558 695)"/>
              <path d="M3361.87-4140.357v18.249" transform="translate(-2786 4844.411)" fill="none" stroke="#fff"
                    strokeLinecap="round" strokeWidth="2"/>
              <path d="M0,0V18.249" transform="translate(584.994 713.178) rotate(90)" fill="none" stroke="#fff"
                    strokeLinecap="round" strokeWidth="2"/>
            </g>
          </svg>
        </button>
      ))}
      <Popover
        id="mouse-over-popover"
        open={Boolean(popoverAnchor)}
        anchorEl={popoverAnchor}
        disableScrollLock
        className='custom custom--system'
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <div className="popover" onMouseLeave={handlePopoverClose}>
          <img src={popoverContent ? popoverContent.img : ''}
               alt={popoverContent ? popoverContent.alt : ''}
               className="popover__img"/>
          <div className="popover__content">
            <p style={{fontSize:`1.8rem`, color:`#f7a600`, fontWeight:`bold`}}>{popoverContent ? popoverContent.text : ''}</p>
            <a href={popoverContent ? popoverContent.href : ''}>Zobrazit více</a>
          </div>
        </div>
      </Popover>
    </div>
  )
}

export default SystemPopup;




// WEBPACK FOOTER //
// ./fe/web-prefa/src/js/components/system/react/index.js